import axios from 'axios';
import authHeader from './auth-header';
import config from '../config';

const API_URL = config.API_URL + '/messages';

class MessageService {
  // Envoyer un message
  sendMessage(receiverUsername, content) {
    return axios.post(API_URL + '/send', {
      receiverUsername,
      content
    }, { 
      headers: authHeader(),
      timeout: 10000
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error('Erreur envoi message:', error.message);
      return Promise.reject(error);
    });
  }

  // Récupérer une conversation avec un utilisateur
  getConversation(otherUsername) {
    console.log('=== SERVICE - RÉCUPÉRATION CONVERSATION ===');
    console.log('URL:', API_URL + `/conversation/${otherUsername}`);
    console.log('Autre utilisateur:', otherUsername);
    
    return axios.get(API_URL + `/conversation/${otherUsername}`, {
      headers: authHeader(),
      timeout: 10000
    })
    .then(response => {
      console.log('Service - Messages reçus:', response.data);
      console.log('Service - Nombre de messages:', response.data?.length || 0);
      return response;
    })
    .catch(error => {
      console.error('Erreur récupération conversation:', error.message);
      console.error('Détails erreur:', error.response?.data);
      return Promise.reject(error);
    });
  }

  // Récupérer toutes les conversations
  getConversations() {
    console.log('=== SERVICE - RÉCUPÉRATION CONVERSATIONS ===');
    console.log('URL:', API_URL + '/conversations');
    console.log('Headers:', authHeader());
    
    return axios.get(API_URL + '/conversations', {
      headers: authHeader(),
      timeout: 10000
    })
    .then(response => {
      console.log('Service - Conversations reçues:', response.data);
      console.log('Service - Nombre de conversations:', response.data?.length || 0);
      return response;
    })
    .catch(error => {
      console.error('Erreur récupération conversations:', error.message);
      console.error('Détails erreur:', error.response?.data);
      return Promise.reject(error);
    });
  }

  // Récupérer les messages reçus
  getReceivedMessages() {
    return axios.get(API_URL + '/received', {
      headers: authHeader(),
      timeout: 10000
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error('Erreur récupération messages reçus:', error.message);
      return Promise.reject(error);
    });
  }

  // Récupérer les messages envoyés
  getSentMessages() {
    return axios.get(API_URL + '/sent', {
      headers: authHeader(),
      timeout: 10000
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error('Erreur récupération messages envoyés:', error.message);
      return Promise.reject(error);
    });
  }

  // Marquer un message comme lu
  markAsRead(messageId) {
    return axios.put(API_URL + `/${messageId}/read`, {}, {
      headers: authHeader(),
      timeout: 10000
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error('Erreur marquage message lu:', error.message);
      return Promise.reject(error);
    });
  }

  // Marquer une conversation comme lue
  markConversationAsRead(otherUsername) {
    return axios.put(API_URL + `/conversation/${otherUsername}/read`, {}, {
      headers: authHeader(),
      timeout: 10000
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error('Erreur marquage conversation lue:', error.message);
      return Promise.reject(error);
    });
  }

  // Récupérer le nombre de messages non lus
  getUnreadCount() {
    return axios.get(API_URL + '/unread-count', {
      headers: authHeader(),
      timeout: 10000
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error('Erreur récupération nombre messages non lus:', error.message);
      return Promise.reject(error);
    });
  }

  // Supprimer un message
  deleteMessage(messageId) {
    return axios.delete(API_URL + `/${messageId}`, {
      headers: authHeader(),
      timeout: 10000
    })
    .then(response => {
      return response;
    })
    .catch(error => {
      console.error('Erreur suppression message:', error.message);
      return Promise.reject(error);
    });
  }
}

export default new MessageService();